import DruhDluhuSelect from './DruhDluhuSelect';

export default DruhDluhuSelect;
